import React, { Children, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { IS_MOBILE } from "@/utils/tool";
import { SOURCE_ORDER_TYPE } from "@/utils/contants";
import TransferConfirmation from "@/components/Modal/TransferConfirmation";
import Order from "./Order";
import "./index.scss";
import { Tabs, message } from "antd";
import PodOrder from "./components/PodOrder";
import { getOrderTypeList } from "@/api/personal";
import EmptyOrder from "./components/Empty";
import { useSearchParams } from "react-router-dom";

const MyOrder: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [transferConfirmationVisible, setTransferConfirmationVisible] =
    useState(false);
  const [curTab, setCurTab] = useState<SOURCE_ORDER_TYPE>();
  const [orderTypeList, setOrderTypeList] =
    useState<Array<SOURCE_ORDER_TYPE>>();
  const [isEmptyTab, setIsEmptyTab] = useState<boolean>();
  const orderItems = useMemo(() => {
    if (!orderTypeList) return [];
    if (orderTypeList.length === 0) return [];
    const list = [
      {
        key: String(SOURCE_ORDER_TYPE.Apc),
        label: t("APC订单"),
        children: (
          <Order
            orderType={SOURCE_ORDER_TYPE.Apc}
            scrollableTargetId={`scrollableEl-${SOURCE_ORDER_TYPE.Apc}`}
          />
        ),
      },
      {
        key: String(SOURCE_ORDER_TYPE.Ptp),
        label: t("PTP订单"),
        children: (
          <Order
            orderType={SOURCE_ORDER_TYPE.Ptp}
            scrollableTargetId={`scrollableEl-${SOURCE_ORDER_TYPE.Ptp}`}
          />
        ),
      },
      {
        key: String(SOURCE_ORDER_TYPE.Ppv),
        label: t("PPV订单1"),
        children: (
          <Order
            orderType={SOURCE_ORDER_TYPE.Ppv}
            scrollableTargetId={`scrollableEl-${SOURCE_ORDER_TYPE.Ppv}`}
          />
        ),
      },
      {
        key: String(SOURCE_ORDER_TYPE.Meeting),
        label: t("会议订单"),
        children: (
          <Order
            orderType={SOURCE_ORDER_TYPE.Meeting}
            scrollableTargetId={`scrollableEl-${SOURCE_ORDER_TYPE.Meeting}`}
          />
        ),
      },
      {
        key: String(SOURCE_ORDER_TYPE.Bpc),
        label: t("BPC订单"),
        children: (
          <Order
            orderType={SOURCE_ORDER_TYPE.Bpc}
            scrollableTargetId={`scrollableEl-${SOURCE_ORDER_TYPE.Bpc}`}
          />
        ),
      },
      {
        key: String(SOURCE_ORDER_TYPE.Pod),
        label: t("纸本期刊服务订单"),
        children: (
          <PodOrder
            scrollableTargetId={`scrollableEl-${SOURCE_ORDER_TYPE.Pod}`}
          />
        ),
      },
    ];
    return list.filter((item) => orderTypeList.includes(Number(item.key)));
  }, [t, orderTypeList]);

  const getOrderType = async () => {
    const res = await getOrderTypeList<{
      order_type: Array<SOURCE_ORDER_TYPE>;
    }>();
    if (res.code !== 0) {
      messageApi.error(res.msg);
      return;
    }
    const paramTab = searchParams.get("tab");
    if (paramTab && res.data.order_type.includes(Number(paramTab))) {
      setCurTab(Number(paramTab));
    } else {
      setCurTab(res.data.order_type[0]);
    }

    setOrderTypeList(res.data.order_type);
  };

  useEffect(() => {
    getOrderType();
  }, []);

  return (
    <>
      {contextHolder}

      <section
        className={`my-order-wrapper ${
          IS_MOBILE ? "mobile-my-order-wrapper" : ""
        }`}
      >
        {orderItems.length > 0 ? (
          <Tabs
            activeKey={String(curTab)}
            destroyInactiveTabPane={false}
            onChange={(key) => setCurTab(Number(key) as SOURCE_ORDER_TYPE)}
            tabBarExtraContent={{
              right: (
                <a
                  className="btn-transfer-confirmation"
                  onClick={() => setTransferConfirmationVisible(true)}
                >
                  {t("线下汇款确认")}
                </a>
              ),
            }}
            items={orderItems}
          />
        ) : (
          ""
        )}
        {orderTypeList && orderTypeList.length === 0 ? (
          <section className="empty-order-wrapper">
            <a
              className="btn-transfer-confirmation"
              onClick={() => setTransferConfirmationVisible(true)}
            >
              {t("线下汇款确认")}
            </a>
            <EmptyOrder />
          </section>
        ) : (
          ""
        )}
      </section>
      {transferConfirmationVisible && (
        <TransferConfirmation
          hiddenModal={() => setTransferConfirmationVisible(false)}
        />
      )}
    </>
  );
};

export default MyOrder;
